import { PatientSummaryDto } from '../../../types/swaggerTypes'
import { isPatientSummaryPostTrialAccess } from '../patientInitialsDisplay'
import { ActionDropdownConstants } from './Patient.model'

type PostTrialAccessEligibility = Pick<PatientSummaryDto, 'programStatus'>

export type PostTrialAccessHiddenAction =
  | ActionDropdownConstants.TransferPatient
  | ActionDropdownConstants.DiscontinuePatient
  | ActionDropdownConstants.DeletePatient

export const ACTIONS_HIDDEN_FOR_POST_TRIAL_ACCESS: PostTrialAccessHiddenAction[] =
  [
    ActionDropdownConstants.TransferPatient,
    ActionDropdownConstants.DiscontinuePatient,
    ActionDropdownConstants.DeletePatient
  ]

export const isPostTrialAccessPatientRow = (
  patient: PostTrialAccessEligibility | null | undefined,
  programDetailCountryProgramStatus?: string | null
): boolean => {
  if (!patient) {
    return false
  }

  return isPatientSummaryPostTrialAccess(
    patient.programStatus,
    programDetailCountryProgramStatus
  )
}

/**
 * CLOS-14563: post-trial access patients cannot be deleted, so rows with a
 * draft order offer Delete order (delete the order and start again) instead.
 */
export const resolveDeleteAction = <TAction>(
  deletePatientAction: TAction,
  deleteOrderAction: TAction,
  patient: PostTrialAccessEligibility | null | undefined,
  programDetailCountryProgramStatus?: string | null
): TAction =>
  isPostTrialAccessPatientRow(patient, programDetailCountryProgramStatus)
    ? deleteOrderAction
    : deletePatientAction

export const applyPostTrialAccessActionRules = <TAction>(
  actions: TAction[],
  actionsByKey: Record<PostTrialAccessHiddenAction, TAction>,
  patient: PostTrialAccessEligibility | null | undefined,
  programDetailCountryProgramStatus?: string | null
): TAction[] => {
  if (
    !isPostTrialAccessPatientRow(patient, programDetailCountryProgramStatus)
  ) {
    return actions
  }

  const hiddenActions = ACTIONS_HIDDEN_FOR_POST_TRIAL_ACCESS.map(
    (actionKey) => actionsByKey[actionKey]
  )

  return actions.filter((action) => !hiddenActions.includes(action))
}
